module.exports = __webpack_public_path__ + "resources/img/sp_service_m.4d31c1ea68eb63b1fbc4dc69fd943c12.png";